import { IQuestionario } from "@deltasge/marauders-map";

import React, { FC, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
  Typography,
} from "@mui/material";
import { ChevronDown as ExpandMoreIcon } from "mdi-material-ui";

import { Environment } from "configs";
import { IFilterDiarioQuestionario } from "interfaces";

export const Filter: FC<{
  Component: () => JSX.Element;
  navigate: (params: IFilterDiarioQuestionario, path?: string) => void;
  filter: IFilterDiarioQuestionario;
  questionarios: IQuestionario[];
}> = ({ Component, navigate, filter, questionarios }) => {
  const [panel, setPanel] = useState({
    questionario: false,
  });

  return (
    <Box
      sx={{
        width: ({ spacing }) => spacing(Environment.DRAWER_WIDTH),
        display: "block",
      }}
    >
      <Component />
      <Accordion
        elevation={0}
        expanded={panel.questionario}
        onChange={() =>
          setPanel((prev) => ({ ...prev, questionario: !panel.questionario }))
        }
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Grid container>
            <Grid item xs={12} component={Typography} variant="subtitle2">
              Questionário
            </Grid>
            <Grid item xs={12} component={Typography} variant="caption">
              {!filter.idQuestionario
                ? "TODOS OS QUESTIONÁRIOS"
                : questionarios.find((f) => f.id == filter.idQuestionario)
                    ?.nome}
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <List dense>
            <ListItemButton
              onClick={() => {
                navigate({ ...filter, idQuestionario: undefined });
              }}
            >
              <ListItemIcon>
                <Radio checked={undefined == filter.idQuestionario} />
              </ListItemIcon>
              <ListItemText primary="TODOS OS QUESTIONÁRIOS" />
            </ListItemButton>
            {questionarios.map((m) => (
              <ListItemButton
                key={`questionario_filter_${m.id}`}
                onClick={() => {
                  navigate({ ...filter, idQuestionario: m.id });
                }}
              >
                <ListItemIcon>
                  <Radio checked={m.id == filter.idQuestionario} />
                </ListItemIcon>
                <ListItemText
                  primary={m.nome}
                  primaryTypographyProps={{
                    noWrap: true,
                  }}
                />
              </ListItemButton>
            ))}
          </List>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
